import { render, staticRenderFns } from "./i4pro-textarea.vue?vue&type=template&id=07eb0d1d"
import script from "./i4pro-textarea.vue?vue&type=script&lang=js"
export * from "./i4pro-textarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports